import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useRef } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import { categoryArticles } from '@/mocks/category';

const categoryTabs = [
  { slug: 'hot', label: '热点' },
  { slug: 'wanghong', label: '网红爆料' },
  { slug: 'mingxing', label: '明星八卦' },
  { slug: 'chigua', label: '吃瓜大赛' },
];

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const currentSlug = slug || 'hot';
  const data = categoryArticles[currentSlug] || categoryArticles.hot;
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -340 : 340,
        behavior: 'smooth',
      });
    }
  };

  const categorySchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${data.title} - 黑料吃瓜网`,
    description: data.description,
    url: 'http://cgshe.cn/category/all',
    isPartOf: {
      '@type': 'WebSite',
      name: '黑料吃瓜网',
      url: 'http://cgshe.cn/',
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: 'http://cgshe.cn/' },
        { '@type': 'ListItem', position: 2, name: data.title },
      ],
    },
  };

  return (
    <>
      <SEO
        title={`${data.title} - 黑料吃瓜网 | 最新${data.title}资讯`}
        description={`黑料吃瓜网${data.title}板块，${data.description}`}
        keywords={`黑料吃瓜网,${data.title},网红爆料,明星八卦,吃瓜`}
        canonical={'http://cgshe.cn/category/all'}
        schemaJson={categorySchema}
      />
      <Navbar />

      <main>
        <section className="pt-20 md:pt-24 pb-8">
          <div className="px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-400 mb-6">
                <Link to="/" className="hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
                <i className="ri-arrow-right-s-line"></i>
                <span className="text-foreground-700">{data.title}</span>
              </nav>

              <div className="flex items-center gap-2 overflow-x-auto pb-2 mb-8">
                {categoryTabs.map((tab) => (
                  <Link
                    key={tab.slug}
                    to="/category/all"
                    className={`px-5 py-2.5 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                      currentSlug === tab.slug
                        ? 'bg-foreground-950 text-background-50'
                        : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100 border border-background-200'
                    }`}
                  >
                    {tab.label}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="pb-14 md:pb-20">
          <div className="px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
                <div className="flex-1 lg:max-w-[40%]">
                  <span className="inline-block px-3 py-1 rounded-md border border-foreground-200 text-xs text-foreground-500 mb-4">
                    {data.title}专区
                  </span>
                  <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight">
                    {data.title}
                    <span className="block text-foreground-400 text-2xl md:text-3xl mt-2">🔥 最新最全资讯</span>
                  </h1>
                  <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed">
                    {data.description}
                  </p>
                  <Link
                    to="/about"
                    className="inline-block mt-6 text-sm text-primary-600 hover:text-primary-700 border-b border-primary-300 hover:border-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    了解更多关于我们 →
                  </Link>
                </div>

                <div className="flex-1 lg:max-w-[55%]">
                  <div className="flex items-end justify-end gap-8 mb-6">
                    {data.stats.map((stat) => (
                      <div key={stat.label} className="text-right">
                        <p className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading">{stat.value}</p>
                        <p className="text-xs text-foreground-400 mt-1">{stat.label}</p>
                      </div>
                    ))}
                  </div>
                  <div className="relative flex gap-4">
                    <div className="w-40 h-48 md:w-48 md:h-56 rounded-2xl overflow-hidden mt-8">
                      <img
                        src="https://readdy.ai/api/search-image?query=Entertainment%20news%20collage%20with%20warm%20coral%20and%20cream%20tones%2C%20abstract%20magazine%20cover%20style%2C%20dynamic%20geometric%20layout%2C%20editorial%20design%20aesthetic%2C%20soft%20gradient%20background&width=400&height=500&seq=cat-hero-img-01&orientation=portrait"
                        alt={data.title}
                        title={data.title}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="w-56 h-72 md:w-64 md:h-80 rounded-2xl overflow-hidden">
                      <img
                        src="https://readdy.ai/api/search-image?query=Social%20media%20trending%20topic%20visualization%20with%20vibrant%20comment%20threads%2C%20warm%20amber%20and%20coral%20color%20palette%2C%20modern%20editorial%20design%2C%20playful%20dynamic%20composition&width=500&height=700&seq=cat-hero-img-02&orientation=portrait"
                        alt={`${data.title}热点`}
                        title={`${data.title}热点内容`}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-foreground-950">
          <div className="px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
                <div>
                  <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-background-50/20 text-background-50/80 text-xs font-medium whitespace-nowrap">
                    换一批
                    <i className="ri-refresh-line"></i>
                  </span>
                  <h2 className="font-heading text-3xl md:text-4xl text-background-50 mt-4">
                    {data.title} · 最新内容
                  </h2>
                </div>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => scroll('left')}
                    className="w-10 h-10 rounded-full border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 flex items-center justify-center transition-colors cursor-pointer"
                    aria-label="向左滚动"
                  >
                    <i className="ri-arrow-left-s-line text-lg"></i>
                  </button>
                  <button
                    onClick={() => scroll('right')}
                    className="w-10 h-10 rounded-full border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 flex items-center justify-center transition-colors cursor-pointer"
                    aria-label="向右滚动"
                  >
                    <i className="ri-arrow-right-s-line text-lg"></i>
                  </button>
                </div>
              </div>

              <div
                ref={scrollRef}
                className="flex gap-5 overflow-x-auto pb-4 -mx-4 px-4 md:-mx-6 md:px-6"
                style={{ scrollSnapType: 'x mandatory' }}
              >
                {data.articles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.id}`}
                    className="flex-shrink-0 w-72 md:w-80 cursor-pointer group"
                    style={{ scrollSnapAlign: 'start' }}
                  >
                    <div className="rounded-2xl overflow-hidden bg-background-100 transition-transform duration-300 group-hover:-translate-y-1">
                      <div className="aspect-[4/3] overflow-hidden">
                        <img
                          src={article.image}
                          alt={article.title}
                          title={article.title}
                          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                        />
                      </div>
                      <div className="p-4 md:p-5">
                        <div className="flex items-center gap-2 mb-2">
                          <span className="text-xs text-foreground-400">{article.date}</span>
                          <span className="text-xs text-foreground-400 flex items-center gap-1">
                            <i className="ri-eye-line"></i>
                            {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                          </span>
                        </div>
                        <h3 className="font-heading text-sm md:text-base text-foreground-950 line-clamp-2 leading-snug">
                          {article.title}
                        </h3>
                        <p className="mt-2 text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                          {article.summary}
                        </p>
                        <div className="mt-3 flex flex-wrap gap-1.5">
                          {article.tags.map((tag) => (
                            <span key={tag} className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs">
                              {tag}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}